import { getFilterSales } from '../services';
export const fetchFilterSale = () => getFilterSales().then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    data: Object.entries(response?.data ?? {}).map(([key, name]) => ({
        key,
        name,
    })),
    errors: response?.errors,
    success: response?.success,
});
